/* cSpell:disable */
import { HeaderConfig } from '@tenants/types/tenant';
import { getSubDomainUrl, RootDomain } from 'constants/domains';
import { LOCALE_EXP_IN_SERVICE_PATHS } from 'types/locales';

/**
 * Creates a header configuration for the eXp In Service tenant.
 *
 * This function generates a standardized header configuration that includes:
 * - Main and authentication button text
 * - Authentication menu items (saved searches, favorites, profile, sign out)
 * - Main navigation menu items (buy, military rewards, in-service life, etc.)
 *
 * @param rootDomain The root domain used to construct the join eXp URL
 * @returns A complete header configuration object with all necessary navigation and authentication elements
 *
 * @example
 * ```typescript
 * const header = createHeaderConfig('exprealty.com');
 * ```
 */
export function createHeaderConfig(rootDomain: RootDomain): HeaderConfig {
  const headerConfig = {
    mainButtonCopy: LOCALE_EXP_IN_SERVICE_PATHS.HEADER_MAINBUTTONCOPY,
    authButtonCopy: LOCALE_EXP_IN_SERVICE_PATHS.HEADER_AUTHBUTTONCOPY,
    hasJoinExpPage: true,
    authMenuItems: [
      {
        label: LOCALE_EXP_IN_SERVICE_PATHS.HEADER_AUTHLINKS_MYSAVEDSEARCHES,
        link: '/account/saved/searches',
        id: 'my-saved-searches',
      },
      {
        label: LOCALE_EXP_IN_SERVICE_PATHS.HEADER_AUTHLINKS_MYFAVOURITES,
        link: '/account/saved/favourites',
        id: 'my-favourites',
      },
      {
        label: LOCALE_EXP_IN_SERVICE_PATHS.HEADER_AUTHLINKS_EDITPROFILE,
        link: '/account/details',
        id: 'edit-profile',
      },
      {
        label: LOCALE_EXP_IN_SERVICE_PATHS.HEADER_AUTHLINKS_SIGNOUT,
        id: 'sign-out',
        signOut: true,
      },
    ],
    menuItems: [
      {
        label: LOCALE_EXP_IN_SERVICE_PATHS.HEADER_MENULINKS_BUY,
        link: '/search?openSearch=true',
        id: 'header-buy-button',
      },
      {
        label: LOCALE_EXP_IN_SERVICE_PATHS.HEADER_MENULINKS_MILITARYREWARDSPROGRAM,
        link: '/military-rewards-program',
        id: 'military-rewards-program-button',
      },
      {
        label: LOCALE_EXP_IN_SERVICE_PATHS.HEADER_MENULINKS_INSERVICELIFE,
        link: '/inservice-life',
        id: 'in-service-life-button',
      },
      {
        label: LOCALE_EXP_IN_SERVICE_PATHS.HEADER_MENULINKS_FINDANAGENT,
        link: '/agents-search',
        id: 'header-find-agent-button',
      },
      {
        label: LOCALE_EXP_IN_SERVICE_PATHS.HEADER_MENULINKS_JOINEXP,
        link: getSubDomainUrl(rootDomain, 'join'),
        newTab: true,
        id: 'header-join-exp-button',
      },
      {
        label: LOCALE_EXP_IN_SERVICE_PATHS.HEADER_MENULINKS_SITEMAP,
        link: '/sitemap',
        id: 'header-sitemap-button',
      },
    ],
  };
  return headerConfig;
}